import React from "react";
import "../Footer.css";
import { Link } from "react-router-dom";
import {

  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaArrowRight,
  FaShieldAlt,
} from "react-icons/fa";

import logo from "../../assets/bluelotus-logo1.png";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">

      {/* Top Footer */}

      <div className="container">

        <div className="footer-grid">

          {/* Company */}

          <div className="footer-column company">

            <img
              src={logo}
              alt="BlueLotus"
              className="footer-logo"
            />

            <p>
              BlueLotus Infrasafety Projects Private Limited delivers enterprise-grade cybersecurity solutions that protect organizations from evolving cyber threats. We specialize in endpoint security, cloud security, network protection, identity management, vulnerability assessments, security operations, compliance, and incident response. Our mission is to help businesses build resilient, secure, and future-ready digital infrastructures through innovative cybersecurity technologies and expert consulting services.
            </p>

            {/* <div className="footer-social">

              <a href="/">
                <FaLinkedinIn />
              </a>

              <a href="/">
                <FaFacebookF />
              </a>

              <a href="/">
                <FaInstagram />
              </a>

              <a href="/">
                <FaXTwitter />
              </a>

            </div> */}

          </div>

          {/* Quick Links */}

          <div className="footer-column">

            <h3>Quick Links</h3>

            <ul>

              <li>
                <a href="/">
                  <FaArrowRight />
                  Home
                </a>
              </li>

              <li>
                <a href="/about">
                  <FaArrowRight />
                  About
                </a>
              </li>

              <li>
                <a href="/solutions">
                  <FaArrowRight />
                  Solutions
                </a>
              </li>

              <li>
                <a href="/bluelotus-secureshield">
                  <FaArrowRight />
                  SecureShield
                </a>
              </li>

              <li>
                <a href="/contact">
                  <FaArrowRight />
                  Contact
                </a>
              </li>

            </ul>

          </div>

          {/* Services */}

          <div className="footer-column">

            <h3>Cybersecurity Solutions</h3>

            <ul>

              <li>
                <a href="/solutions">
                  <FaShieldAlt />
                  Network Security
                </a>
              </li>

              <li>
                <a href="/solutions">
                  <FaShieldAlt />
                  Cloud Security
                </a>
              </li>

              <li>
                <a href="/solutions">
                  <FaShieldAlt />
                  Endpoint Protection
                </a>
              </li>

              <li>
                <a href="/solutions">
                  <FaShieldAlt />
                  VAPT
                </a>
              </li>

              <li>
                <a href="/solutions">
                  <FaShieldAlt />
                  SOC Monitoring
                </a>
              </li>

              <li>
                <a href="/solutions">
                  <FaShieldAlt />
                  Incident Response
                </a>
              </li>

            </ul>

          </div>

          {/* Contact */}

          <div className="footer-column">

            <h3>Contact Us</h3>

            <div className="contact-item">

              <FaMapMarkerAlt />

              <a
                href="https://maps.google.com/?q=No1 Mukteshwar Apartment H16 Near Pachimeswar Temple Ankuli Brahmapur Ganjam Odisha 760010"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-item"
              >

               
                <span>
                  No.1, Mukteshwar Apartment, H16,
                  Near Pachimeswar Temple
                  <br />
                  Ankuli, Brahmapur Sadar,
                  Ganjam, Odisha, India - 760010
                </span>

              </a>

            </div>

            <div className="contact-item">

              <FaPhoneAlt />

              <span>
                <a href="tel:+916822892309">
                  06822892309
                </a>

              </span>

            </div>

            <div className="contact-item">

              <FaEnvelope />

              <span>
                <a href="mailto:sites@bluelotusprojects.in">
                  sites@bluelotusprojects.in
                </a>

              </span>

            </div>

            <div className="support-box">

              <h4>24×7 Security Support</h4>

              <p>
                Helping businesses stay secure with continuous monitoring
                and rapid incident response.
              </p>

            </div>

          </div>

        </div>

      </div>

      {/* Bottom Footer */}

      <div className="footer-bottom">

        <div className="container footer-bottom-content">

          <p>
            © {year} BlueLotus Infrasafety Projects Private Limited.
            All Rights Reserved.
          </p>

          <div className="footer-bottom-links">

            <a href="/privacy-policy">
              Privacy Policy
            </a>

            <a href="/terms-conditions">
              Terms & Conditions
            </a>

            <a href="/sitemap">
              Sitemap
            </a>

          </div>

        </div>

      </div>

    </footer>
  );
};

export default Footer;